// let oldPushState = history.pushState;
// history.pushState = function pushState() {
//   let ret = oldPushState.apply(this, arguments);
//   console.log('push', arguments)
//   if (arguments[1] !== 'anchor-product' && arguments[0]?.hasOwnProperty('refinementList')) {
//   }
//   return ret;
// };

if (!customElements.get('mobile-bag')) {
  customElements.define('mobile-bag', class MobileBag extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', (event) => {
        event.preventDefault()
        event.stopImmediatePropagation()
        event.stopPropagation()
        const variants = JSON.parse(this.getAttribute('data-variants')).sort((a, b) => Number(a.text) - Number(b.text))
        window.mobileTrackingHit = JSON.parse((this.getAttribute('data-hit')))
        document.querySelector('.mobile-quick-add').classList.remove('no-select')
        document.querySelector('.mobile-quick-add .q-value').innerHTML =
          variants.map(item => `<div class="q-item size-var ${item.text.toLowerCase()} ${item.available ? '' : 'oss'} ${variants.length === 1 ? 'active' : ''}" data-id="${item.id}">${item.text.toUpperCase()}</div>`).join('')

        if (variants.length === 1) {
          document.querySelector('.mobile-quick-add .q-value').style.display = 'none'
          window.mobileQuickAddTargetVariant = Number(variants[0].id)
          document.querySelector('mobile-quick-add .q-text').classList.remove('disabled')
          document.querySelector('mobile-quick-add header div').style.display = 'none'
        } else {
          document.querySelector('.mobile-quick-add .q-value').style.display = 'flex'
          document.querySelector('mobile-quick-add header div').style.display = 'block'
        }
        setTimeout(() => document.querySelectorAll('mobile-quick-add .q-item').forEach(item => item.addEventListener('click', (event) => {
          document.querySelectorAll('mobile-quick-add .q-item').forEach(sub => sub.classList.remove('active'))

          event.target.classList.add('active')
          window.mobileQuickAddTargetVariant = Number(event.target.getAttribute('data-id'))
          document.querySelector('mobile-quick-add .q-text').classList.remove('disabled')
          document.querySelector('.mobile-quick-add').classList.remove('no-select')
        })), 50)
        document.querySelector('.ais-mobile-quick-add').classList.add('visible')
      })
    }
  })
}

if (!customElements.get('pdp-redirect')) {
  customElements.define('pdp-redirect', class PDPRedirect extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('click', () => {
        const url = new URL(location);
        url.searchParams.set("page", this.getAttribute('data-page'));
        history.pushState({}, "anchor-product", url);
        location.href = this.getAttribute('data-url')
        sessionStorage.setItem('plp-object-id', this.getAttribute('data-object-id'))
      })
    }
  })
}

window.renderVariantIndex = 0

function triggerLoadMore() {
  if (document.querySelector('.ais-InfiniteHits-loadMore')
      ?.classList.contains('ais-InfiniteHits-loadMore--disabled')) {
    return
  }

  if (document.querySelector('.ais-InfiniteHits-loadMore'))   {
    window.renderVariantIndex = 0
    document.querySelector('.ais-page').classList.add('ais-loading')
    document.querySelector('.ais-InfiniteHits-loadMore')?.click()
  } else {
    setTimeout(() => {
      triggerLoadMore()
    }, 100)
  }
}

// let isFirstLoadMore = true
document.addEventListener('DOMContentLoaded', () => {
  if (location.pathname.includes('collections') || location.pathname.includes('search')) {
    let watchFooter

    let footer = document.querySelector('#shopify-section-footer')

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!document.querySelectorAll('.ais-InfiniteHits-item').length) {
          return
        }
        if (entry.isIntersecting) {
          triggerLoadMore()
        }
      });
    }, {
      threshold: 0,
      // rootMargin: watchFooter
      //   ? '0px 0px 0px 0px'
      //   : `${footer.clientHeight * 2}px 0px 0px 0px`
    });

    observer.observe(footer)

    let loadPreScrollAnchor = null
    let needScrollForPrevious = false
    let hasSetUpLoadPrevious = false

    const listObs = new MutationObserver((mutations) => {
      // console.log(mutations)
      if (!hasSetUpLoadPrevious) {
        document.querySelector('.ais-InfiniteHits-loadPrevious')?.addEventListener('click', () => {
          loadPreScrollAnchor = document.querySelector('.ais-InfiniteHits-list li:nth-child(1)')
          needScrollForPrevious = true
        })
        hasSetUpLoadPrevious = true
      } else if (needScrollForPrevious && mutations.find(item => item.target.classList.contains('ais-InfiniteHits-list'))) {
        setTimeout(() => {
          loadPreScrollAnchor.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
          })
        }, 200)
        needScrollForPrevious = false
      }
    })

    listObs.observe(document.querySelector('.ais-hits-container'), {
      childList: true,
      subtree: true
    })
  }


  function setAutoCompleteTop() {
    const panel = document.querySelector('.aa-Panel')
    if (panel && window.innerWidth > 680) {
      const rect = document.querySelector('#header .main-search .search-wrap .form').getBoundingClientRect()
      panel.style.top = `${rect.bottom + window.scrollY}px`
    }
  }

  window.addEventListener('scroll', () => {
    setAutoCompleteTop()
  })

  document.querySelector('#header').addEventListener('transitionend', () => {
    setAutoCompleteTop()
  })
  document.querySelector('.nav-search').addEventListener('click', (e) => {
    // if (window.innerHeight <= 680) {
    //   $('.aa-DetachedSearchButton').click()
    //   console.log('search click')
    // } else {
    const child = e.target.matches(".nav-search, .nav-search *");
    if (child) {

      $('body').addClass('se-st');
      setTimeout(function () {
        $('body').addClass('se');

        if (window.innerWidth <= 680) {
          document.querySelector('.aa-DetachedSearchButton').click()
          document.body.style.overflow = 'hidden'
          setTimeout(() => {
            document.querySelector('.aa-DetachedCancelButton').addEventListener('click', () => {
              document.body.style.overflow = ''
              document.querySelector('.main-search .close').click()
            })
          }, 50);
          setTimeout(() => {

            // document.getElementById('autocomplete-0-input').setAttribute('autofocus', 'autofocus');
            // console.log(document.getElementById('autocomplete-0-input'));

            // document.getElementById('autocomplete-0-input').click();

          }, 500);
        } else {
          $('#autocomplete-0-input').focus()
        }
      }, 50);
    }

    // }
  })

})

if (!customElements.get('swipe-handle')) {
  customElements.define('swipe-handle', class SwipeHandle extends HTMLElement {
    constructor(props) {
      super(props);

      this.addEventListener('click', event => {
        event.stopPropagation()
        event.stopImmediatePropagation()
        event.preventDefault()

        if (this.classList.contains('pre-btn')) {
          window[`fy_${this.getAttribute('data-object-id')}`].previous()
        } else {
          window[`fy_${this.getAttribute('data-object-id')}`].next()
        }
      })
    }

  })
}
window.mobileCheck = function () {
  let check = false;
  (function (a) {
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('.top_desktop .close').addEventListener('click', () => {
    document.body.removeChild(
      document.querySelector('.aa-Panel:last-child')
    )
  })
  if (!mobileCheck()) {
    history.scrollRestoration = 'manual';
  }

  document.querySelector('.cart-btn button')?.addEventListener('click', () => {
    try {
      const localStorageKey_pdp = 'localStorageKey_pdp';
      algoliaShopify.saveForConversionTracking(JSON.parse(localStorage.getItem(localStorageKey_pdp)));
    } catch (e) {
      console.error(e)
    }
  })


})
